import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';

const AboutSection: React.FC = () => {
  const advantages = [
    'Meer dan 35 jaar ervaring in de elektrotechniek',
    'Persoonlijke service van begin tot eind',
    'Erkend elektrotechnisch installatiebedrijf',
    '24 uur per dag telefonisch bereikbaar',
    'Hoogwaardige materialen en vakmanschap',
    'Duidelijke communicatie en vrijblijvende offertes',
  ];

  return (
    <section className="py-20 bg-white">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <motion.div
            initial={{ opacity: 0, x: -50 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
          >
            <div className="relative">
              <img
                src="/generated-1786479847285-ln4b7.png"
                alt="HTS Electrotechniek - bedrijfsauto"
                className="rounded-2xl shadow-xl w-full object-cover"
                style={{ aspectRatio: '4/3' }}
              />
              <div className="absolute -bottom-6 -right-6 bg-orange-500 text-white p-5 rounded-xl shadow-xl hidden md:block">
                <p className="font-bold text-2xl">Sinds 2000</p>
                <p className="text-sm text-orange-50">Meer dan 23 jaar betrouwbare service</p>
              </div>
            </div>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, x: 50 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
          >
            <span className="section-eyebrow">Wie wij zijn</span>
            <h2 className="text-3xl md:text-4xl font-bold mb-6 text-navy-800">
              HTS Electrotechniek: Kwaliteit & Ervaring
            </h2>
            <p className="text-navy-700 mb-5 leading-relaxed">
              HTS Electrotechniek is een erkend elektrotechnisch installatiebedrijf, 
              opgericht in april 2000 door Halit Suiçmez, met ervaring in de sector sinds 1987. 
              We richten ons op het leveren van kwalitatief hoogwaardig werk voor zowel 
              particuliere als zakelijke klanten.
            </p>
            <p className="text-navy-700 mb-8 leading-relaxed">
              Alle projecten worden van begin tot eind uitgevoerd door één en dezelfde persoon, 
              wat zorgt voor consistentie en persoonlijke service. Deze persoonlijke aanpak stelt 
              ons in staat om maatwerk te leveren en de hoogste kwaliteit te garanderen.
            </p>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-8">
              {advantages.map((advantage, index) => (
                <div key={index} className="flex items-start">
                  <CheckCircle2 className="text-orange-500 mr-3 mt-1 flex-shrink-0" size={20} />
                  <p className="text-navy-800">{advantage}</p>
                </div>
              ))}
            </div>

            <a
              href="/about"
              className="btn-secondary"
            >
              Meer over ons
              <svg
                className="w-4 h-4 ml-2"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M14 5l7 7m0 0l-7 7m7-7H3"
                />
              </svg>
            </a>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
